import { AxiosRequestConfig, AxiosResponse } from "axios";
import apiGuard from "../../../context-controller-mod/context-serv/global-provider/api-shell/api-gaurd";

const ApiPatch = <T = unknown, B = unknown>(
  url: string,
  body?: B,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  return apiGuard.patch<T>(url, body, config);
};

export default ApiPatch;